import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth.module'
import register from './register.module'
import profile from './profile.module'
import users from './users.module'
import roles from './roles.module'
import layers from './layers.module'
import workspaces from './workspaces.module'
import maps from './maps.module'
import topics from './topics.module'
import groupunits from './groupunits.module'
import layergroups from './layergroups.module'
import extents from './extents.module'
import fonmaps from './fonmaps.module'
import datastore from './datastore.module'
import errors from './errors.module.js'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		auth,
		register,
		profile,
		users,
		roles,
		layers,
		workspaces,
		maps,
		topics,
		groupunits,
		layergroups,
		extents,
		fonmaps,
		datastore,
		errors
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js